/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCartEventFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, type CartEvent, type ErrorResponse, type InternalErrorResponse } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/orders/{-id}/cart-events
 */
export interface CartEventsRequestBuilder extends BaseRequestBuilder<CartEventsRequestBuilder> {
    /**
     * Every recorded change to the cart the order was placed from (lines, quantities, notes, prices, discounts, codes, price refreshes, review requests and returns, submission), with who made it, through which surface, and the value before and after, oldest first. Events written on a rep's device appear once the device has pushed them.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CartEvent[]>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {ErrorResponse} error when the service returns a 404 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<CartEventsRequestBuilderGetQueryParameters> | undefined) : Promise<CartEvent[] | undefined>;
    /**
     * Every recorded change to the cart the order was placed from (lines, quantities, notes, prices, discounts, codes, price refreshes, review requests and returns, submission), with who made it, through which surface, and the value before and after, oldest first. Events written on a rep's device appear once the device has pushed them.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<CartEventsRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * Every recorded change to the cart the order was placed from (lines, quantities, notes, prices, discounts, codes, price refreshes, review requests and returns, submission), with who made it, through which surface, and the value before and after, oldest first. Events written on a rep's device appear once the device has pushed them.
 */
export interface CartEventsRequestBuilderGetQueryParameters {
    /**
     * For a sales rep who belongs to several organizations: the organization to read from. It mustbe one of the organizations the caller's OrgCodes header grants.
     */
    useOrganizationId?: string;
}
/**
 * Uri template for the request builder.
 */
export const CartEventsRequestBuilderUriTemplate = "{+baseurl}/api/orders/{%2Did}/cart-events{?useOrganizationId*}";
/**
 * Metadata for all the requests in the request builder.
 */
export const CartEventsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: CartEventsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createCartEventFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
